<div class="content">
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  <div class="inputRow">
    <mat-form-field class="selectionInput">
      <mat-label>Description</mat-label>
      <input matInput [(ngModel)]="description" [disabled]="isBusy()"/>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="selectionInput">
      <mat-label>Input Type</mat-label>
      <mat-select [(ngModel)]="metricInput" [disabled]="isBusy()">
        <mat-option [value]="false">Imperial</mat-option>
        <mat-option [value]="true">Metric</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="selectionInput">
      <mat-label>System Type</mat-label>
      <mat-select [(ngModel)]="selectedSystemTypeCode" (ngModelChange)="systemTypeChanged()" [disabled]="isBusy()">
        @for (systemType of systemTypes; track systemType) {
          <mat-option [value]="systemType.code">
            {{ systemType.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <span class="inputColumn">
      @if (showCoolingFluid) {
        <mat-form-field class="fluidTypeInput">
          <mat-label>Cooling Fluid</mat-label>
          <mat-select [(ngModel)]="coolingFluidTypeCode" [disabled]="isBusy()">
            @for (fluidType of fluidTypes(); track fluidType) {
              <mat-option [value]="fluidType.code">
                {{ fluidType.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isGlycol(coolingFluidTypeCode)) {
        <mat-form-field class="glycolPercentInput">
          <mat-label>Cooling Glycol %</mat-label>
          <input matInput [(ngModel)]="coolingGlycolPercent" type="number"/>
        </mat-form-field>
      }
    </span>
    <span class="inputColumn">
      @if (showHeatingFluid) {
        <mat-form-field class="fluidTypeInput">
          <mat-label>Heating Fluid</mat-label>
          <mat-select [(ngModel)]="heatingFluidTypeCode" [disabled]="isBusy()">
            @for (fluidType of fluidTypes(); track fluidType) {
              <mat-option [value]="fluidType.code">
                {{ fluidType.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isGlycol(heatingFluidTypeCode)) {
        <mat-form-field class="glycolPercentInput">
          <mat-label>Heating Glycol %</mat-label>
          <input matInput [(ngModel)]="heatingGlycolPercent" type="number"/>
        </mat-form-field>
      }
    </span>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="elevated" (click)="cancel()" [disabled]="isBusy()" class="dialogButton warn-button">Cancel</button>
    <button matButton="elevated" (click)="save()" [disabled]="isBusy() || !canSave()" class="dialogButton primary-button">
      Save
    </button>
  </div>
</div>
